export default __webpack_public_path__ + "static/media/microflow_4.7ea1e3ba.png";